import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class SellerInvoiceDiscountingService {

  constructor(private http: Http, private router: Router) { }

  public applyDiscounting(invoiceDiscountData) {
    console.log('inside services');
    const poId = localStorage.getItem('sellerPoId');
    const data = {
        'emailId': invoiceDiscountData.emailId,
        'gst': 1,
        'invoiceAmount': invoiceDiscountData.invoiceAmount,
        'invoiceId': invoiceDiscountData.invoiceId,
        'invoiceStatus': 'Unregistered',
        "manualInvoice": false
      };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/seller/invoiceDiscount',
     body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public applyMIDiscounting(invoiceDiscountData) {
    console.log('inside services');
    const poId = localStorage.getItem('sellerPoId');
    const data = {
        'emailId': invoiceDiscountData.emailId,
        'gst': 1,
        'invoiceAmount': invoiceDiscountData.invoiceAmount,
        'invoiceId': invoiceDiscountData.invoiceId,
        'invoiceStatus': 'Unregistered',
        "manualInvoice": true
      };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/seller/invoiceDiscount',
     body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public listDiscountedBills() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/seller/invoiceDiscount', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public filterDiscountedBills(buyerDiscountedInvID: any) {
    console.log('inside services');
    const billId = buyerDiscountedInvID;
    const sellerId = sessionStorage.getItem('billSellerId');
    const invoiceFlag = sessionStorage.getItem('billInvoiceFlag');
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', headerToken); 
    let myParams = new URLSearchParams();
    myParams.append('sellerId', sellerId);  
    myParams.append('manualInvoice', invoiceFlag);  
    let options = new RequestOptions({ headers: myHeaders, params: myParams });
    return this.http.get(environment.baseUrl + '/seller/invoiceDiscount/' + billId, options).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public OnRequestLiquidation(liqData, billReferenceNo) {
    console.log('inside services');
    const data = {
        'billReferenceNo': billReferenceNo,
        'repaymentAmount': liqData.liqAmount
      };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/seller/invoiceDiscount',
     body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public paginationBill(newOffset, limit) {
    console.log('pagination', newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
     return this.http.get(environment.baseUrl + '/banker/invoiceDiscount',
     {headers: headers, params : {
      offset: newOffset,
      limit: limit
     }})
     .map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
 }

    public previousPage(previousUrl) {
     console.log('on previous page', previousUrl);
      return this.http.get(environment.baseUrl + '/banker/invoiceDiscount' + previousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
       console.log(response.status);
       const user = response.json();
       user.responseStatus = response.status;
       console.log(user);
       return user;
     }).catch((error) => {
       console.log('error', error);
       if (error.status === 500) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 400) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 401) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       }
   });
  }

  public NextPage(nextUrl, newOffset, limit) {
   console.log('on next page', nextUrl, newOffset, limit);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount',
    {headers: headers, params : {
     offset: newOffset,
     limit: limit
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
 }

 public filterBillByURL(offset: any, limit: any) {
   console.log('href on services', offset, limit);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
   return this.http.get(environment.baseUrl  + '/banker/invoiceDiscount', {headers: headers, params : {
     offset: offset,
     limit: limit
    }})
   .map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 400) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 401) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    }
 });
 }

   public filterBillOffset() {
    console.log('offset');
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount',
    {headers: headers, params : {
     offset: '0',
     limit: '10'
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
   }
}
